import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-kundesla-list-view',
  imports: [],
  templateUrl: './kundesla.list-view.html',
  styleUrls: ['./kundesla.list-view.css'],
})
export class KundeslaListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
